/**
 * Timeline del historial de status del expediente.
 *
 * Renderiza una línea de tiempo simple con badges de estado +
 * timestamp + nota opcional de cada transición.
 */

import { ProjectStatusBadge } from "@/components/ProjectStatusBadge";
import { type StatusHistoryEntryDTO } from "@/lib/api";

import { formatDate } from "./_shared";

export function TimelineSection({ history }: { history: StatusHistoryEntryDTO[] }) {
  return (
    <section
      aria-label="Historial"
      data-testid="timeline"
      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-xs"
    >
      <h2 className="mb-3 text-sm font-semibold text-slate-900">Timeline</h2>
      <ol className="space-y-3 border-l border-slate-200 pl-4">
        {history.map((entry, idx) => (
          <li key={idx} className="relative">
            <span className="absolute top-1 left-[-21px] h-2 w-2 rounded-full bg-brand-500 ring-2 ring-white" />
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <ProjectStatusBadge status={entry.to_status} />
              <span className="font-mono text-slate-500">{formatDate(entry.created_at)}</span>
            </div>
            {entry.notes && <p className="mt-1 text-xs text-slate-600">{entry.notes}</p>}
          </li>
        ))}
      </ol>
    </section>
  );
}
